import { Checkbox, FormControlLabel, type FormControlLabelProps } from "@mui/material";
import { Controller, type FieldValues, type Path, useFormContext } from "react-hook-form";
import { type ElementTracking, useElementTracking } from "../../../analytics/analytics";

interface Props<TFieldValues extends FieldValues> {
  name: Path<TFieldValues>;
  label?: string;
  labelPlacement?: FormControlLabelProps["labelPlacement"];
  disabled?: boolean;
}

export const CeCheckbox = <TFieldValues extends FieldValues>({
  name,
  label,
  labelPlacement,
  analyticsCategory,
  disabled,
}: Props<TFieldValues> & ElementTracking): React.JSX.Element => {
  const { control } = useFormContext<TFieldValues>();
  const analyticsProps = useElementTracking(analyticsCategory, name, "check");

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const checkbox = (
          <Checkbox
            disabled={disabled}
            checked={field.value}
            onChange={(_, checked) => {
              field.onChange(checked);
            }}
          />
        );
        return label ? (
          <FormControlLabel
            {...analyticsProps}
            control={checkbox}
            label={label}
            labelPlacement={labelPlacement}
          />
        ) : (
          checkbox
        );
      }}
    />
  );
};
